import { AdminPage } from './AdminPage';

interface Props {
  isAdmin: boolean;
  currentUserId: string;
  onBack: () => void;
}

/**
 * Control Panel — admin-only host for tenant-level settings.
 *
 * Сейчас содержит единственный таб «Пользователи» — управление
 * ростером. Каталог пространств раньше тоже жил здесь, но переехал
 * в обычный раздел `_app` (`/spaces`), доступный любому пользователю
 * напрямую из сайдбара.
 *
 * Не-админ сюда не попадает: «Панель управления» в сайдбаре открывается
 * только для admin-роли (`_app.tsx` решает, что делать по клику).
 */
export function ControlPanel({ isAdmin, currentUserId, onBack }: Props) {
  return (
    <div className="cp-page">
      <div className="cp-sidebar">
        <button className="cp-back" onClick={onBack}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M19 12H5" />
            <path d="M12 19l-7-7 7-7" />
          </svg>
          Назад к чату
        </button>

        {isAdmin && (
          <>
            <div className="cp-section-title">Администрирование</div>
            <div className="cp-nav">
              <button className="cp-nav-item active" type="button">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
                Пользователи
              </button>
            </div>
          </>
        )}
      </div>

      <div className="cp-content">
        {isAdmin && <AdminPage currentUserId={currentUserId} />}
      </div>
    </div>
  );
}
